import * as ChangePhysicalPersonDataTypes from 'src/actions/physical-person/change-data/Types';
import {
  ChangePhysicalPersonData,
  ChangePhysicalPersonDataAction
} from 'src/actions/physical-person/change-data/ChangePhysicalPersonData.actions';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';

export interface PhysicalPersonFormState {
  physicalPerson?: PhysicalPersonData;
  loading: boolean;
}

const initialState: PhysicalPersonFormState = {
  loading: false
};

export function PhysicalPersonFormReducer(state: PhysicalPersonFormState = initialState,
                                          action: ChangePhysicalPersonDataAction): PhysicalPersonFormState {
  switch (action.type) {
    case ChangePhysicalPersonDataTypes.CHANGE_PHYSICAL_PERSON_DATA:
      const physicalPerson: PhysicalPersonData = (action as ChangePhysicalPersonData).payload;
      return {...state, physicalPerson: physicalPerson, loading: false};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/physical-person/PhysicalPersonFormReducer.tsx